import React from 'react';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import dayjs from "../dayjs-config";
import FormattedDate from "../FormattedDate/FormattedDate";
dayjs.extend(localizedFormat);

var FormattedTime = function FormattedTime(_ref) {
  var time = _ref.time,
      variant = _ref.variant;
  return React.createElement(FormattedDate, {
    variant: variant,
    date: time,
    format: "time",
    "data-qa": "formatted-time"
  });
};

export default FormattedTime;